import { render, staticRenderFns } from "./DownloadsPage.vue?vue&type=template&id=b857a7b4&"
import script from "./DownloadsPage.vue?vue&type=script&lang=js&"
export * from "./DownloadsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports